module.exports = __webpack_public_path__ + "img/Reports.e9b600f9.svg";